export default __webpack_public_path__ + "static/thank-you-multilanguage-684ef4defb19bbbcd0714bf68a903583.png";